// ============================================
// src/config/firebase.config.js
// ============================================

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCs22kg-ERdECuurlJSnawdEO_dztMWcug",
  authDomain: "community-management-f772d.firebaseapp.com",
  projectId: "community-management-f772d",
  storageBucket: "community-management-f772d.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1036944170453",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1036944170453:web:8e50abda2f5304707f315c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Initialize Firebase Messaging (only if supported)
let messaging = null;
isSupported().then(supported => {
  if (supported) {
    messaging = getMessaging(app);
  }
});

export { messaging };